import type { CookieRef } from 'nuxt/app';
import { useCookie } from '#imports';

export interface UseCookieRedirectReturn {
	/**
     * The reactive value of the redirect path cookie.
     * Can be both read and written to.
     */
	path: CookieRef<string | null>;
	/**
     * Get the current redirect path cookie value, then clear it
     */
	pluck: () => string | null;
}

export const useCookieRedirect = (): UseCookieRedirectReturn => {
	const cookie: CookieRef<string | null> = useCookie(
		`redirect-path`,
		{
			readonly: false,
		},
	);

	return {
		path: cookie,
		pluck: () => {
			const value = cookie.value;
			cookie.value = null;
			return value;
		},
	};
};
